import {
  createFrontendModule,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { convertLegacyRouteRef } from '@backstage/core-compat-api';
import { searchPlugin } from '@backstage/plugin-search';

/**
 * Override the search plugin's page to render our custom SearchPage
 * with ADR and Confluence search result types.
 */
const searchPage = PageBlueprint.make({
  params: {
    path: '/search',
    title: 'Search',
    routeRef: convertLegacyRouteRef(searchPlugin.routes.root),
    loader: () =>
      import('../../components/search/SearchPage').then(m => m.searchPage),
  },
});

export const searchPageModule = createFrontendModule({
  pluginId: 'search',
  extensions: [searchPage],
});
